import Head from 'next/head';
interface Props {
  id: string;
  headline: string;
  description: string;
  imagesList: string[];
  createdAt: string;
  updatedAt: string;
  userFullName: string;
}
const ArticleSchema = ({
  id,
  headline,
  description,
  imagesList,
  createdAt,
  updatedAt,
  userFullName
}: Props) => {
  const ldImages = (imagesList || []).join(', ') || 'https://dehaat.in/assets/images/login-chacha.webp';
  const jsonld = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${id}`
    },
    headline: `${headline}`,
    description: `${description}`,
    image: [`${ldImages}`],
    datePublished: `${new Date(createdAt).toLocaleDateString('zh-Hans-CN')}`,
    dateModified: `${new Date(updatedAt).toLocaleDateString('zh-Hans-CN')}`,
    author: {
      '@type': 'Person',
      name: `${userFullName}`,
      url: 'https://dehaat.in/'
    },
    publisher: {
      '@type': 'Organization',
      name: 'DeHaat',
      url: 'https://dehaat.in/',
      logo: {
        '@type': 'ImageObject',
        url: 'https://dehaat/logo.svg'
      }
    }
  };
  return <Head data-sentry-element="Head" data-sentry-component="ArticleSchema" data-sentry-source-file="ArticleSchema.tsx">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonld)
    }} />
    </Head>;
};
export default ArticleSchema;